import { useEffect, useState } from 'react';
// import { Subject } from 'react-hook-form/dist/utils/createSubject';
import { Subject } from 'src/models/classes';
import { useIntl } from 'react-intl';
import Select from 'src/components/_common/Select/Select';
import ClassesContext from 'src/hooks/useClasses';
import SubjectsContext from 'src/hooks/useSubjects';
import { SimpleUser } from 'src/models/classes';
import { User } from 'src/models/user';

interface SubjectResponsibleSelectProps {
  isTeacher: boolean;
  selectedSubjectIds: number[] | undefined;
  setSelectedSubjectIds: (subjectIds: number[]) => void;
  user: User;
}

interface SelectOption {
  value: string;
  label: string;
}

function isIterable(obj: any) {
  // checks for null and undefined
  if (obj == null) {
    return false;
  }
  return typeof obj[Symbol.iterator] === 'function';
}

type SubjectWithIdAndCode = Subject & { id: number; subjectCode: string };

function hasIdAndCode(subject: Subject): subject is SubjectWithIdAndCode {
  return subject.id !== undefined && subject.subjectCode !== undefined;
}

export default function SubjectResponsibleSelect({ isTeacher, selectedSubjectIds, setSelectedSubjectIds, user }: SubjectResponsibleSelectProps) {
  const { formatMessage } = useIntl();
  const { subjects } = SubjectsContext.useContainer();

  const validSubjects = (subjects ?? []).filter(hasIdAndCode);

  const convertSubjectToSelectOption = (subject: SubjectWithIdAndCode) => ({ value: subject.id.toString(), label: subject.subjectCode });

  useEffect(() => {
    if (user.subjectsResponsible === undefined) return;
    setSelectedSubjectIds(user.subjectsResponsible ?? []);
  }, [user, subjects]);

  if (subjects === undefined) return null;
  if (!isTeacher || !user) return null;

  const getValues = (subjectIds: number[] | undefined): SelectOption[] | undefined => {
    if (!subjectIds || subjectIds.length === 0) return undefined;
    const selectedSubjects = validSubjects.filter(s => subjectIds.some(_s => _s === s.id));
    return selectedSubjects.map(convertSubjectToSelectOption);
  };

  const handleChange = (newSubjectOptions: SelectOption[]) => {
    const newSubjects = newSubjectOptions
      .map(option => validSubjects.find(c => c.id.toString() === option.value))
      .filter(option => option !== undefined) as SubjectWithIdAndCode[];
    setSelectedSubjectIds(newSubjects.map(s => s.id));
  };

  return (
    <Select
      label={formatMessage({ id: 'subject-responsible' })}
      value={getValues(selectedSubjectIds)}
      options={validSubjects.map(convertSubjectToSelectOption)}
      onChange={values => {
        if (isIterable(values)) {
          handleChange([...values]);
        } else {
          const value: SelectOption = values as any;
          handleChange([value]);
        }
      }}
      isMulti
      isClearable
    />
  );
}
